import axios from 'axios'
// import config from '../../config/index';
import {RETURN_URL,LOGIN_URL,IS_YH,IS_NMG,IS_RC} from "../../config/index";

//axios.defaults.baseURL = config.API_SERVER_BASE;
axios.defaults.timeout = 60000;
axios.defaults.headers.post['Content-Type'] = 'application/json';
axios.defaults.headers.common['companyId'] = 58;//融创58、粤海147、生产58
//axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded'
axios.defaults.withCredentials = true

axios.interceptors.request.use(function (config) {
	// Do something before request is sent

	return config;
}, function (error) {
	// Do something with request error

	return Promise.reject(error);
});
// Add a response interceptor
axios.interceptors.response.use(function (response) {
	// Do something with response data
	var code = response.data.status
	if (code === 40002 || code === 40003 || code === 40005) {
		window.location.href = LOGIN_URL+'/loginOut?url='+encodeURIComponent(RETURN_URL+"/jump-page")
		return;
	}
	// if (code === 401) {
	// 	var curhref = encodeURIComponent(window.location.href)
	// 	window.location.href = '/wechat/to-login?rurl=' + curhref
	// 	return;
	// }
	return response;
}, function (error) {
	// Do something with response error

	return Promise.reject(error);
});

export default axios;



// WEBPACK FOOTER //
// ./src/assets/js/axios.js